<div class="content" *ngIf="!success && !error">
  <form class="form-container"  [formGroup]="formControls" autocomplete="off" action="" [style.height.px]="formHeight">
    <div class="label-wrapper">
      <label>{{'UserName' | cpLoginTranslate | async}}:</label>
    </div>

    <div class="input-wrapper">
      <input class="disabled" type="text" [(ngModel)]="userName" formControlName="userName" [readonly]="true"
             autocomplete="off" autocorrect="off" autocapitalize="off" maxlength="50"/>
    </div>

    <div class="label-wrapper">
      <label>{{'OldPassword' | cpLoginTranslate | async}}:</label>
    </div>

    <div class="input-wrapper">
      <input #OldPassword [type]="!passwordVisible ? 'password' : 'text'" formControlName="oldPassword" autofocus autocomplete="off" autocorrect="off" autocapitalize="off" maxlength="25"
             (keypress)="resetErrors()"/>

      <span class="field-icon-wrapper">
        <i class="field-icon"
           [ngClass]="passwordVisible ? 'pp-icon-hide': 'pp-icon-show'"
           cpClickableElement [elementDescription]="(passwordVisible ? 'HidePassword' : 'ShowPassword') | cpActionTranslate | async"
           elementRole="switch"
           [attr.aria-checked]="passwordVisible"
           (click)="togglePasswordVisibility()">
		    </i>
      </span>

      <label *ngIf="formControls.controls['oldPassword'].touched && formControls.controls['oldPassword'].hasError('required')" class="text-invalid">
        {{'OldPasswordRequired' | cpLoginTranslate | async}}
      </label>

      <label *ngIf="oldPasswordInCorrect" class="text-invalid">
        {{'OldPasswordInCorrect' | cpLoginTranslate | async}}
      </label>

      <label *ngIf="invalidCharacters && formControls.controls['oldPassword'].touched && formControls.controls['oldPassword'].valid" class="text-invalid">
        {{'PasswordContainsInvalidChars' | cpLoginTranslate | async}}
      </label>

    </div>

    <app-set-password #PasswordForm [changePassword]="true"></app-set-password>

  </form>

  <div class="buttons-wrapper">
    <cp-button class="primary-button call-to-action" captionToTranslate="ChangePassword.Login.PP" [disabled]="inProgress" (onClick)="changePassword()"></cp-button>
  </div>
</div>

<div class="action-result" *ngIf="success">
  <i class="pp-icon-status_confirm"></i>
  <div class="title-primary">{{'PasswordChangedSuccessfully' | cpLoginTranslate | async}}</div>
  <div class="buttons-wrapper">
    <cp-button class="primary-button call-to-action" captionToTranslate="Close.Login.PP" (onClick)="window.close()"></cp-button>
  </div>
</div>

<div class="action-result" *ngIf="error">
  <i class="pp-icon-error"></i>
  <div *ngIf="errorText" class="title-primary">{{errorText | cpLoginTranslate | async}}</div>
  <div *ngIf="accountLocked" class="title-primary">{{'PatientPortalAccountLocked' | cpLoginTranslate : [sysConfig.LockExpirationTimeInMinutes.toString()] | async}}</div>

  <app-information-box class="information-details"
                       [text1]="informationText"
                       [icon]="'pp-icon-info'">
  </app-information-box>

  <div class="buttons-wrapper" *ngIf="!informationText">
    <cp-button class="primary-button call-to-action" captionToTranslate="Back.Login.PP" (onClick)="backFromError()"></cp-button>
  </div>
</div>

<div [ngClass]="inProgress ? 'overlay' : ''"></div>

<div *ngIf="inProgress" class="progress-spinner">
  <div class="loading-image"></div>
</div>
